import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { BuyNowModalPaymentFallback } from '@/modules/buy-now/components/BuyNowModalPaymentFallback';

export const BuyNowErrorModal = () => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const modalElement = document.getElementById('buy-now-payment-error-modal');

  if (!isMounted) return null;
  if (!modalElement) return null;

  return createPortal(<BuyNowModalPaymentFallback />, modalElement);
};

export { BuyNowModalPaymentFallback };
